const ACTIONS = {
    CHANGE_CARD_INDEX: 'CHANGE_CHARD_INDEX',
    CHANGE_NUM_CARDS_VISIBLE: 'CHANGE_NUM_CARDS_VISIBLE',
    SCROLLED_INTO_VIEW: 'SCROLLED_INTO_VIEW'
};

const ACTION_CREATORS = {
    changeCardIndex: (newCardIndex) => (
        {type: ACTIONS.CHANGE_CARD_INDEX, payload: {cardIndex: newCardIndex}}
    ),
    changeNumCardsVisible: (numCardsVisible) => (
        {type: ACTIONS.CHANGE_NUM_CARDS_VISIBLE, payload: {numCardsVisible}}
    ),
    scrolledIntoView: () => (
        {type: ACTIONS.SCROLLED_INTO_VIEW}
    )
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/tripboard/recommended-properties/actions/index.js